export default __webpack_public_path__ + "static/1-4b2e8d61eece68b94c591bf708c9ca34.webp";